import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/about">About</Link>
        <Link to="/contact">Contact Us</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms &amp; Conditions</Link>
        <Link to="/refund-policy">Refund Policy</Link>
        <Link to="/grievance-officer">Grievance Officer</Link>
        <Link to="/accessibility">Accessibility</Link>
      </div>
      <p style={{ marginTop: '0.75rem', fontSize: '0.75rem', color: '#888', lineHeight: 1.6 }}>
        All readings are AI-generated and for entertainment purposes only. Not professional advice.
      </p>
      <p style={{ marginTop: '0.5rem' }}>{t('footerBrand')}</p>
      <p style={{ marginTop: '0.5rem' }}>
        {t('footerPowered')}
      </p>
    </footer>
  );
}
